import React, { Component } from 'react';
import './App.css';
import { fetchUtils, Admin, Resource, Delete } from 'admin-on-rest';
// import { UsersCreate, UsersEdit, UsersList } from './resources/users';
// import { ProfilesCreate, ProfilesEdit, ProfilesList } from './resources/profiles';
// import { TeamsCreate, TeamsEdit, TeamsList } from './resources/teams';
// import { MeasurementsCreate, MeasurementsEdit, MeasurementsList } from './resources/measurments';
import { FoodsCreate, FoodsEdit, FoodsList } from './resources/foods';
import { MealsCreate, MealsEdit, MealsList } from './resources/meals';
import { MealCategoriesCreate, MealCategoriesShow, MealCategoriesEdit, MealCategoriesList } from './resources/mealCategories';
import { CategoriesCreate, CategoriesShow, CategoriesEdit, CategoriesList } from './resources/categories';
import addUploadFeature from './addUploadHandler';
import authClient from './authClient';
import amtRestClient from './restClient';

const httpClient = (url, options = {}) => {
  if (!options.headers) {
    options.headers = new Headers({ Accept: 'application/json' });
  }
  if (options.range) {
    options.headers.set('Range', options.range.toString());
  }
  const token = localStorage.getItem('token');
  if (token) {
    options.headers.set('Authorization', `Bearer ${token}`);
  }
  return fetchUtils.fetchJson(url, options);
}

const restClient = amtRestClient(process.env.REACT_APP_API_URL, httpClient);
const uploadCapableClient = addUploadFeature(restClient);

class App extends Component {
  render() {
    return (
      <Admin title="AMT Panel" restClient={uploadCapableClient} authClient={authClient}>
        {/*<Resource name="users" list={UsersList} create={UsersCreate} edit={UsersEdit} remove={Delete} />*/}
        {/* <Resource name="profiles" list={ProfilesList} create={ProfilesCreate} edit={ProfilesEdit} remove={Delete} /> */}
        {/* <Resource name="teams" list={TeamsList} create={TeamsCreate} edit={TeamsEdit} remove={Delete} /> */}
        {/* <Resource name="measurements" list={MeasurementsList} create={MeasurementsCreate} edit={MeasurementsEdit} remove={Delete} /> */}
        <Resource name="categories" list={CategoriesList} show={CategoriesShow} create={CategoriesCreate} edit={CategoriesEdit} remove={Delete} />
        <Resource name="foods" list={FoodsList} create={FoodsCreate} edit={FoodsEdit} remove={Delete} />
        <Resource name="mealscategories" options={{ label: 'Meals Categories' }} show={MealCategoriesShow} list={MealCategoriesList} create={MealCategoriesCreate} edit={MealCategoriesEdit} remove={Delete} />
        <Resource name="meals" list={MealsList} create={MealsCreate} edit={MealsEdit} remove={Delete} />
      </Admin>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js